// Shared inline styles for the Admin dashboard panels.
const adminStyles = {
  page: {
    minHeight: '100vh',
    paddingTop: '3rem',
    paddingBottom: '4rem',
    backgroundColor: '#FAF9F6',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
    padding: '0 1.5rem',
  },
  title: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '3rem',
    color: '#1A1918',
    marginBottom: '2rem',
  },
  tabs: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '2rem',
    borderBottom: '1px solid #EAE5DD',
  },
  tab: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '1rem 1.5rem',
    fontSize: '1rem',
    color: '#585755',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
    borderBottom: '2px solid transparent',
  },
  tabActive: {
    backgroundColor: 'transparent',
    border: 'none',
    padding: '1rem 1.5rem',
    fontSize: '1rem',
    color: '#C5A059',
    cursor: 'pointer',
    borderBottom: '2px solid #C5A059',
    fontWeight: 500,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '2rem',
    flexWrap: 'wrap',
    gap: '1rem',
  },
  sectionTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '2rem',
    color: '#1A1918',
  },
  btnPrimary: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    backgroundColor: '#C5A059',
    color: 'white',
    border: 'none',
    padding: '0.75rem 1.5rem',
    fontSize: '0.875rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: 500,
  },
  btnSecondary: {
    backgroundColor: 'transparent',
    color: '#1A1918',
    border: '1px solid #1A1918',
    padding: '0.75rem 1.5rem',
    fontSize: '0.875rem',
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    fontWeight: 500,
  },
  form: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '2rem',
    marginBottom: '2rem',
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gap: '1.5rem',
    marginBottom: '1.5rem',
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    marginBottom: '1rem',
  },
  label: {
    color: '#585755',
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  input: {
    padding: '0.75rem',
    border: '1px solid #EAE5DD',
    backgroundColor: '#FAF9F6',
    color: '#1A1918',
    fontSize: '1rem',
    fontFamily: "'Manrope', sans-serif",
    outline: 'none',
    transition: 'border-color 0.3s ease',
  },
  checkboxGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    marginBottom: '1rem',
  },
  checkboxLabel: {
    color: '#585755',
    fontSize: '0.9rem',
  },
  formActions: {
    display: 'flex',
    gap: '1rem',
    marginTop: '1.5rem',
  },
  table: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '80px 2fr 1fr 1fr 120px',
    gap: '1rem',
    padding: '1rem',
    borderBottom: '1px solid #EAE5DD',
    alignItems: 'center',
  },
  tableCell: { color: '#585755', fontSize: '0.9rem' },
  cellSubtext: { color: '#8C8B88', fontSize: '0.8rem', marginTop: '0.25rem' },
  thumbnail: {
    width: '70px',
    height: '70px',
    objectFit: 'cover',
    border: '1px solid #EAE5DD',
  },
  iconButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#585755',
    cursor: 'pointer',
    padding: '0.5rem',
    transition: 'color 0.3s ease',
    marginRight: '0.5rem',
  },
  deleteButton: { color: '#9E3E3E' },
  analyticsGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '2rem',
  },
  analyticsCard: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '2rem',
    textAlign: 'center',
  },
  analyticsValue: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '3rem',
    color: '#C5A059',
    margin: '1rem 0',
  },
  analyticsLabel: { color: '#585755', fontSize: '1rem' },
  analyticsTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.5rem',
    color: '#1A1918',
    marginBottom: '1rem',
  },
  analyticsList: { listStyle: 'none', padding: 0, textAlign: 'left' },
  analyticsListItem: {
    color: '#585755',
    fontSize: '0.9rem',
    padding: '0.5rem 0',
    borderBottom: '1px solid #EAE5DD',
  },
  emptyText: { color: '#8C8B88', fontSize: '0.9rem' },
  importStatusCard: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '2rem',
    marginBottom: '2rem',
  },
  statusTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.5rem',
    color: '#1A1918',
    marginBottom: '1.5rem',
  },
  statusGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '2rem',
  },
  statusItem: { display: 'flex', flexDirection: 'column', gap: '0.5rem' },
  statusLabel: {
    color: '#585755',
    fontSize: '0.875rem',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  statusValue: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '2rem',
    color: '#C5A059',
    fontWeight: 500,
  },
  importCard: {
    backgroundColor: 'white',
    border: '1px solid #EAE5DD',
    padding: '2.5rem',
  },
  importTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.5rem',
    color: '#1A1918',
    marginBottom: '1rem',
  },
  importText: {
    color: '#585755',
    fontSize: '1rem',
    lineHeight: 1.7,
    marginBottom: '2rem',
  },
  importInfo: {
    marginTop: '3rem',
    padding: '1.5rem',
    backgroundColor: '#FAF9F6',
    border: '1px solid #EAE5DD',
  },
  infoTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.25rem',
    color: '#1A1918',
    marginBottom: '1rem',
  },
  infoList: {
    color: '#585755',
    fontSize: '0.9rem',
    lineHeight: 1.8,
    paddingLeft: '1.5rem',
  },
  langSection: {
    backgroundColor: '#FAF9F6',
    border: '1px solid #EAE5DD',
    padding: '1.5rem',
    marginBottom: '1.5rem',
  },
  langSectionTitle: {
    fontFamily: "'Playfair Display', serif",
    fontSize: '1.25rem',
    color: '#1A1918',
    marginBottom: '1rem',
  },
};

export default adminStyles;
